import React from "react";
import { Box, Typography, Grid, useTheme, useMediaQuery } from "@mui/material";
import projects from "../../data/projects.js";

const ProjectDescription = ({ projectId }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const project = projects.find((p) => p.id === parseInt(projectId));

  if (!project) {
    return (
      <Typography variant="body1" sx={{ p: 4, textAlign: "center" }}>
        Proyecto no encontrado
      </Typography>
    );
  }

  const {
    title,
    fullDescription,
    fullDescription2,
    objectives,
    approach,
    client,
    categoryLabel,
    ubication,
  } = project;

  return (
    <Box
      sx={{
        padding: isMobile ? "0 20px" : "0 120px",
        boxSizing: "border-box",
      }}
    >
      {/* Logo + título en fila de artículo */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: isMobile ? 2 : 4,
          mt: isMobile ? 3 : 5,
          mb: isMobile ? 2 : 4,
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        <Box
          component="img"
          src={project.image}
          alt={title}
          sx={{
            width: isMobile ? "120px" : "160px",
            height: isMobile ? "120px" : "160px",
            objectFit: "contain",
            flexShrink: 0,
            borderRadius: "12px",
            backgroundColor: "#f5f5f5",
            p: 1,
          }}
        />
        <Typography
          variant="h4"
          sx={{
            fontSize: isMobile ? "28px" : "40px",
            fontWeight: "bold",
            color: "#164d8d",
          }}
        >
          {title}
        </Typography>
      </Box>

      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Grid container spacing={isMobile ? 2 : 4}>
          <Grid item xs={12} md={8} sx={{ marginRight: isMobile ? 0 : "40px" }}>
            <Box
              sx={{
                pr: { md: 4 },
                borderRight: { md: "1px solid #e0e0e0" },
                paddingRight: isMobile ? 0 : "20px",
              }}
            >
              <Typography
                variant="body1"
                gutterBottom
                sx={{
                  fontSize: isMobile ? "16px" : "18px",
                  color: "#868686",
                  marginBottom: "20px",
                  lineHeight: 1.8,
                }}
              >
                {fullDescription}
              </Typography>
              {fullDescription2 && (
                <Typography
                  variant="body1"
                  gutterBottom
                  sx={{
                    fontSize: isMobile ? "16px" : "18px",
                    color: "#868686",
                    marginBottom: "40px",
                    lineHeight: 1.8,
                  }}
                >
                  {fullDescription2}
                </Typography>
              )}
              <Typography
                variant="h6"
                gutterBottom
                sx={{
                  fontSize: isMobile ? "22px" : "28px",
                  fontWeight: "bold",
                  color: "#164d8d",
                  marginTop: isMobile ? "30px" : "40px",
                  marginBottom: "20px",
                }}
              >
                Objetivos
              </Typography>
              <Typography
                variant="body1"
                gutterBottom
                sx={{
                  fontSize: isMobile ? "16px" : "18px",
                  color: "#868686",
                  marginBottom: "40px",
                  lineHeight: 1.8,
                }}
              >
                {objectives}
              </Typography>
<Typography
                variant="h6"
                gutterBottom
                sx={{
                  fontSize: isMobile ? "22px" : "28px",
                  fontWeight: "bold",
                  color: "#164d8d",
                  marginTop: "20px",
                  marginBottom: "20px",
                }}
              >
                Acercamiento Consermacom
              </Typography>
              <Typography
                variant="body1"
                gutterBottom
                sx={{
                  fontSize: isMobile ? "16px" : "18px",
                  color: "#868686",
                  marginBottom: "40px",
                  lineHeight: 1.8,
                }}
              >
                {approach}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={4} sx={{ marginLeft: isMobile ? 0 : "-40px" }}>
            <Box sx={{ pl: { md: 4 }, marginLeft: isMobile ? 0 : "-20px" }}>
              <Typography
                variant="h6"
                gutterBottom
                sx={{
                  marginTop: isMobile ? "10px" : "50px",
                  fontWeight: "bold",
                  color: "#164d8d",
                }}
              >
                Cliente
              </Typography>
              <Typography
                variant="body1"
                gutterBottom
                sx={{ marginBottom: isMobile ? "20px" : "40px", color: "#868686" }}
              >
                {client}
              </Typography>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold", color: "#164d8d" }}>
                Categoría
              </Typography>
              <Typography
                variant="body1"
                gutterBottom
                sx={{ marginBottom: isMobile ? "20px" : "40px", color: "#868686" }}
              >
                {categoryLabel}
              </Typography>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold", color: "#164d8d" }}>
                Ubicación
              </Typography>
              <Typography
                variant="body1"
                gutterBottom
                sx={{ marginBottom: isMobile ? "20px" : "40px", color: "#868686" }}
              >
                {ubication}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default ProjectDescription;
